import { render, staticRenderFns } from "./TableRightColumn.vue?vue&type=template&id=2eb62c0a&scoped=true&"
import script from "./TableRightColumn.vue?vue&type=script&lang=js&"
export * from "./TableRightColumn.vue?vue&type=script&lang=js&"
import style0 from "./TableRightColumn.vue?vue&type=style&index=0&id=2eb62c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb62c0a",
  null
  
)

export default component.exports